import SuperLayout from './SuperLayout';

export default SuperLayout;
